<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >规则详情</el-button
    >
    <el-dialog
      :visible.sync="dialogVisible"
      title="FBS详情规则介绍"
      width="1200px"
      @close="closeDialog"
    >
      <el-form
        :model="content"
        ref="contentForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="语言类型：" prop="language">
          中文
        </el-form-item>
        <el-form-item label="内容：" prop="textCha">
          <editor v-model="content[1]" class="editor"></editor>
        </el-form-item>
        <el-form-item label="语言类型：" prop="language">
          英文
        </el-form-item>
        <el-form-item label="内容：" prop="textEng">
          <editor v-model="content[4]" class="editor"></editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('contentForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Editor from 'components/editor';

export default {
  name: 'CreateContent',
  data() {
    return {
      dialogVisible: false,
      content: {},
      rules: {
        1: [{ required: true, message: '中文规则不能为空！' }]
      }
    };
  },
  components: {
    Editor
  },
  computed: {
    ...mapState('contentSetting', ['languageList'])
  },
  methods: {
    ...mapActions('purchaseProject', ['createRules', 'getRules']),
    closeDialog() {
      this.$refs['contentForm'].resetFields();
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.createRules(this.content).then(() => {
            this.$message.success('添加成功！');
            this.dialogVisible = false;
          });
        }
      });
    }
  },
  mounted() {
    this.getRules().then(res => {
      this.content = res.data.map;
    });
  }
};
</script>

<style lang="less" scoped>
.editor {
  height: 500px;
}
</style>
